import { type RefObject } from 'react';

import type {
  PinchMoveProps,
  PointerEventModifiers,
  RelativeAbsolutePosition,
  SwipeMoveProps,
} from '../../../types/pointer-events.js';
import type { InteractionTriggers, ZoomBehavior } from '../types.js';
import { reset } from './reset.js';

export const getGestures = ({
  lastMousePositionRef,
  panDeltaRef,
  onZoomStart,
  onZoomChange,
  onZoomEnd,
  onPanStart,
  onPanChange,
  onPanEnd,
}: {
  lastMousePositionRef: RefObject<RelativeAbsolutePosition | undefined>;
  panDeltaRef: RefObject<number | undefined>;

  onZoomStart?: (event: { triggeredBy: InteractionTriggers }) => void;
  onZoomChange?: (event: {
    triggeredBy: InteractionTriggers;
    deltaStart: number;
    deltaEnd: number;
    behavior: ZoomBehavior;
  }) => void;
  onZoomEnd?: (event: { triggeredBy: InteractionTriggers }) => void;
  onPanStart?: (event: { triggeredBy: InteractionTriggers }) => void;
  onPanChange?: (event: {
    triggeredBy: InteractionTriggers;
    delta: number;
  }) => void;
  onPanEnd?: (event: { triggeredBy: InteractionTriggers }) => void;
}) => ({
  onPinchStart: () => {
    reset(lastMousePositionRef, panDeltaRef);

    onZoomStart?.({ triggeredBy: 'pointer' });
  },

  onPinchMove: (event: PinchMoveProps & PointerEventModifiers) => {
    const { delta } = event;

    const pinchIn = delta > 0;

    onZoomChange?.({
      triggeredBy: 'pointer',
      deltaStart: delta,
      deltaEnd: -delta,
      behavior: pinchIn ? 'zoom-in' : 'zoom-out',
    });
  },

  onPinchEnd: () => {
    onZoomEnd?.({ triggeredBy: 'pointer' });
  },

  onSwipeStart: () => {
    onPanStart?.({ triggeredBy: 'pointer' });
  },

  onSwipeMove: (event: SwipeMoveProps & PointerEventModifiers) => {
    const { deltaX } = event;

    onPanChange?.({ triggeredBy: 'pointer', delta: -deltaX });
  },

  onSwipeEnd: () => {
    onPanEnd?.({ triggeredBy: 'pointer' });
  },
});
